module.exports = __webpack_public_path__ + "static/media/1POLICY29.9e4aad44.jpg";